import { formatDistanceToNowStrict } from 'date-fns';
let theme = {};
if (process.env.REACT_APP_THEME_FILE) import(process.env.REACT_APP_THEME_FILE).then(({
  default: themeObj
}) => theme = themeObj).catch(e => console.log('Module Not Found', e));
class Notification {
  constructor({
    pk,
    verb,
    is_read,
    created_at,
    ...rest
  }) {
    this.pk = pk;
    this.text = verb || '';
    this.status = is_read || false;
    this.url = this.genrateURL({
      pk,
      verb,
      is_read,
      ...rest
    });
    this.dateTime = this.generateDatetimeDiff(created_at);
    this.createdAt = created_at || new Date();
  }
  genrateURL({
    target_content_type_name,
    target_object_id,
    ...rest
  }) {
    let url = '';
    switch (target_content_type_name) {
      case 'organisations_employee':
        url = `/users/${target_object_id}/user`;
        break;
      case 'customers_customer':
        url = `/customers/${target_object_id}/customer`;
        break;
      case 'organisations_organisation':
        url = `/company-settings/basic`;
        break;
      default:
        url = '';
    }
    if (theme?.generateNotificationUrl) url = theme.generateNotificationUrl({
      target_content_type_name,
      target_object_id,
      ...rest
    });
    return url;
  }
  generateDatetimeDiff(created_at) {
    const datetime = formatDistanceToNowStrict(Date.now(created_at));
    switch (datetime.split(' ')[1]) {
      case 'seconds':
        return 'Just now';
      case 'day':
        return 'Yesterday';
      case 'minute':
      case 'minutes':
      case 'days':
      case 'hour':
      case 'hours':
        return `${datetime} ago`;
      default:
        return created_at;
    }
  }
}
export default Notification;